import React, { useState } from "react";
import { useImportProjectMutation } from "../../store/slices/settingsSlice";
import MyModal from "../../Common/MyModal";
import { Form, Tab, Tabs } from "react-bootstrap";
import { toast } from "react-toastify";
import WhiteButton from "../../Common/WhiteButton";
import ContactsIcon from "../../../assets/icons/contact_edit.svg2";
import JsonCollapse from "./JsonCollapse";
import FullScreenLoadingIndicator from "../../Common/FullScreenLoadingIndicator";
import SolutionImportInput from "../../Solutions/SolutionImportInput";
import HelpButton from "../../HelpContent/HelpButton";
import { useGetContactSetsQuery } from "../../store/slices/contactsSlice";
import { useGetReportingTopicsQuery } from "../../store/slices/reportingSlice";
import { useUpdateApiConnectionMutation } from "../../store/slices/settingsSlice";

export default function ProjectImportModal() {
  const [importedJSON, setImportedJSON] = useState<any>();
  const [manualFields, setManualFields] = useState<string[]>([]);
  const [importProject] = useImportProjectMutation();
  const [loading, setLoading] = useState(false);
  const [apiProfiles, setApiProfiles] = useState<any>({});
  const { data: { contactSets } = { contactSets: [] } } =
    useGetContactSetsQuery({
      page: 0,
      perPage: 100,
    });
  const { data: { data: reportingTopics } = { data: [] } } =
    useGetReportingTopicsQuery({ pagination: { page: 0, perPage: 100 } });
  const [updateApiConnection] = useUpdateApiConnectionMutation();

  return (
    <MyModal
      label={
        <WhiteButton
          as="span"
          icon={ContactsIcon}
          heading="Import"
          subheading="Component"
          target={undefined}
          disabled={false}
        />
      }
      heading={
        <span>
          Import Component <HelpButton helpKey="import-component" />
        </span>
      }
      onShow={() => setImportedJSON(undefined)}
      size="xxl"
    >
      {({ handleClose }) => (
        <>
          <FullScreenLoadingIndicator loading={loading} />
          <Form.Control
            className="mb-3"
            type="file"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const file = e.target.files?.[0];
              if (!file) return;
              setLoading(true);
              const reader = new FileReader();
              reader.readAsText(file, "UTF-8");
              reader.onload = function ({ target }) {
                setImportedJSON(JSON.parse(target?.result as string));
                setLoading(false);
              };
              reader.onerror = function () {
                setImportedJSON(undefined);
                setLoading(false);
              };
            }}
          />
          {!!importedJSON && (
            <div
              className="bg-white p-2 rounded-2"
              style={{ maxHeight: "700px", overflowY: "auto" }}
            >
              <Tabs mountOnEnter>
                {Object.entries(importedJSON?.Bag?.External || {}).map(
                  ([fieldType, fields]) => {
                    const entries = Object.entries(fields || {}) as [
                      string,
                      any,
                    ][];
                    if (!entries.length) return null;

                    return (
                      <Tab
                        key={fieldType}
                        eventKey={fieldType}
                        title={
                          fieldType === "ContactField"
                            ? "Contact fields"
                            : fieldType === "ContactSet"
                              ? "Contact Sets"
                              : fieldType === "ReportingTemplate"
                                ? "Reporting Templates"
                                : fieldType === "Topic"
                                  ? "Reporting Topics"
                                  : fieldType === "ApiConnection"
                                    ? "API Connection"
                                    : fieldType
                        }
                      >
                        <div className="p-3 bg-purple-gradient rounded-2">
                          {entries.map(([fieldKey, value]) => (
                            <SolutionImportInput
                              key={fieldKey}
                              fieldType={fieldType}
                              fieldKey={fieldKey}
                              value={value}
                              importedJSON={importedJSON}
                              setImportedJSON={setImportedJSON}
                              manualFields={manualFields}
                              setManualFields={setManualFields}
                              contactSets={contactSets || []}
                              reportingTopics={reportingTopics || []}
                              apiProfiles={apiProfiles}
                              setApiProfiles={setApiProfiles}
                              updateApiConnection={updateApiConnection as any}
                            />
                          ))}
                        </div>
                      </Tab>
                    );
                  }
                )}
              </Tabs>
            </div>
          )}
          <button
            className="btn btn-colored"
            onClick={async () => {
              if (!importedJSON) return;

              const result: any = await importProject(importedJSON);

              if (result?.data) {
                toast.success("Project imported successfully");
                handleClose();
              }
            }}
          >
            Import Component
          </button>
        </>
      )}
    </MyModal>
  );
}
